import { render, staticRenderFns } from "./ShowList.vue?vue&type=template&id=4bb22287&scoped=true&"
import script from "./ShowList.vue?vue&type=script&lang=js&"
export * from "./ShowList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb22287",
  null
  
)

export default component.exports